import { createSlice } from "@reduxjs/toolkit";
import { Funds, Vehicles } from "../libs/staticData";

const initialState = {
  value: {
    vehicles: Vehicles,
    riskCategories: [
      { id: 1, name: "Conservative" },
      { id: 2, name: "Moderately Conservative" },
      { id: 3, name: "Cautious" },
      { id: 4, name: "Moderate" },
      { id: 5, name: "Moderately Aggressive" },
      { id: 6, name: "Aggressive" },
    ],
    funds: Funds,
  },
};

export const investVehicleSlice = createSlice({
  name: "investVehicle",
  initialState,
  reducers: {},
});

export default investVehicleSlice.reducer;
